<div class="flex-content-wrapper">
    <div class="container-lg">
        <div class="flex-content-wrapper__content row">
            <div class="flex-content-wrapper__column  col-12 offset-md-2 col-md-8 text-center">
                <h2 class="flex-content-wrapper__header" [innerHTML]="block.data.text ? block.data.text : block.data.heading"></h2>
                <div class="flex-content-wrapper__text" [innerHTML]="block.data.content"></div>
            </div>
        </div>
    </div>
</div>
